<script>
  import { onMount } from "svelte";
  import { Link } from "../router";
  import CookieConsent from "../component/CookieConsent.svelte";
  import Header from "../component/Header.svelte";
  import Copyright from "../component/Copyright.svelte";

  import { HStack, VStack, Spacer } from "../component/layout";
  import { Label, Image } from "../component/widget";

  onMount(() => {
    console.log("mount", "help");
  });
</script>

<main>
  <CookieConsent />
  <Header />

  <nav>
    <Link to="/">Home</Link>
  </nav>

  <VStack alignment="center">
    <HStack>
      <Spacer />
      <Label text="A" />
      <Label text="B" />
      <Label text="C" />
      <Spacer />
    </HStack>
    <span>Croque Monsieur</span>
    <span>3 Ingrédients</span>
    <Image src="images/logo_small.png" alt="logo" on:click={console.log("click")} />
  </VStack>

  <Copyright company="KiwisApp" />
</main>
